<template>
    <div>
        <b-card-actions action-collapse title="Comments">
            <b-button @click="showCommentForm"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'" 
                variant="outline-primary" class="mr-2">
                Add Comment
            </b-button>
            <b-button @click="showLogForm" 
                v-ripple.400="'rgba(113, 102, 240, 0.15)'" 
                variant="outline-dark">
                Logs
            </b-button>

            <app-timeline v-if="commentData && id" class="mt-3">
                <template v-for="(comment,key) in commentData" >
                    <app-timeline-item variant="info" :key="'comments-'+key"  v-if="key==0" >
                        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                            <h6>{{ comment.title }}</h6>
                            <small class="text-muted">{{ formatDate(comment.created_at) }}</small>
                        </div>
                    
                        <b-media>
                            <template #aside v-if="comment.avatar_url">
                                <b-avatar :src="comment.avatar_url"  />
                            </template>

                            <template #aside v-else>
                                <b-avatar :src="require('@/assets/images/avatars/8-small.png')" />
                            </template>
                        
                            <h6>{{ comment.created_name }}
                                    <b-badge variant="danger" 
                                        style="cursor:pointer;" 
                                        v-if="userData.id == comment.created_by" 
                                        @click="deleteComment(comment.id)"> Delete </b-badge>
                            </h6>
                            <p class="mb-0" style="white-space: pre-line;">{{ comment.comment }}</p>
                        </b-media>
                    </app-timeline-item>
                </template>
            </app-timeline>
        </b-card-actions>

        <b-sidebar
            id="sidebar-right"
            bg-variant="white"
            v-model="isSidebarCommentOpen"
            no-header
            right
            backdrop
            shadow
            ref="formOwner"
            class="side-bar-responsive"
        >
            <template >
                <div class="d-flex justify-content-between align-items-center 
                    content-sidebar-header px-2 py-1">
                    <h5 class="mb-0"> Comment </h5>
                    <div>
                        <feather-icon
                            class="ml-1 cursor-pointer"
                            icon="XIcon"
                            size="16"
                            @click="closeCommentForm"
                        />
                    </div>
                </div>
                <comments :id="id" :type="'house'"
                    v-if="isSidebarCommentOpen" 
                    v-on:childToClose="onSubmitClose"/>
            </template>      
        </b-sidebar>

        <b-sidebar
            id="log-right"
            bg-variant="white"
            v-model="isSidebarLogOpen"
            no-header
            right
            backdrop
            shadow
            ref="logs"
            class="side-bar-responsive"
        >
            <template>
                <div class="d-flex justify-content-between align-items-center 
                    content-sidebar-header px-2 py-1">
                    <h5 class="mb-0"> Logs </h5>
                    <div>
                        <feather-icon
                            class="ml-1 cursor-pointer"
                            icon="XIcon"
                            size="16"
                            @click="closeLogForm"
                        />
                    </div>
                </div>
                <logs :id="id" :type="'house'" v-if="isSidebarLogOpen" />  
            </template>
        </b-sidebar>
    </div>
</template>

<script>
import {
    BButton, VBToggle, BSidebar, BMedia, BBadge, BAvatar,
} from 'bootstrap-vue'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import Ripple from 'vue-ripple-directive'
import Logs from '../../components/logs/Logs.vue'
import Comments from '../../components/comments/Comments.vue'
import router from '@/router'
import axios from '@axios'
import moment from 'moment'

export default {
    components: {
        BCardActions, BButton, BSidebar, Logs, Comments, AppTimeline, AppTimelineItem, BMedia, BBadge,
        BAvatar,
    },
    directives: {
        'b-toggle': VBToggle,
        Ripple,
    },
    data() {
        return {
            id: router.currentRoute.params.id,
            isSidebarLogOpen:false,
            isSidebarCommentOpen:false,
            commentData: [],
            userData: JSON.parse(localStorage.getItem('userData')),
        }
    },
    created(){
        this.getComments();
    },
    methods: {
        async getComments() {
            const data = {
                types: 'comment',
                perPage: 1,
                currentPage: 1,
                house_id: this.id
            }

            const response = await  axios.post(`v1/house/comment`, data);
            if(response.data.success){
                this.commentData = response.data.data;
            }
        },
        async deleteComment(id){
            this.$bvModal
                .msgBoxConfirm('Please confirm that you want to delete Comment', {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if(value === true){
                        axios.delete(`v1/house/comment/delete/${id}`).then(res => {
                            this.makeToast('success','Delete Comment','Completed');
                            this.getComments();
                        });
                    }
                })
        },
        showLogForm(){
            this.isSidebarLogOpen = true;
        },
        closeLogForm(){
            this.isSidebarLogOpen = false;
        },
        showCommentForm(){
            this.isSidebarCommentOpen = true;
        },
        closeCommentForm(){
            this.isSidebarCommentOpen = false;
        },
        onSubmitClose(){
            this.closeCommentForm()
            this.getComments();
        },
        formatDate(date) {
            return date ? moment(date).local().format('DD/MM/YYYY HH:mm') : ''
        },
        makeToast(variant = null, title, message) {
            this.$bvToast.toast(message, {
                title: title,
                variant,
                solid: true,
            })
        },
    },
}
</script>